import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    top: 'calc(50% - 50px)',
  },
}));
